export const environment = {
  production: false,
  apiUrl: 'https://api.redelivery.dev.k8s.redj.ar',
  // apiUrl: 'https://localhost:5001',
  // apiUrl: 'https://localhost:44304',
  primaryColorHex: '#f1c30f',
  storeId: 2,
};
